<template>
  <div>
    <img v-if="display.image" :src="imagePath" alt="image.description" class="cover-imgCouv boxShadow" ref="image">
    <div class="modal fade" :id="'modal-' + index"  data-keyboard="false" data-backdrop="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title font-red-sunglo bold uppercase text-center">Veuillez redimensionner l'image.<a :href="'#modal-' + index" data-toggle="modal" class="btn pull-right closeModal"><i class="fas fa-times fa-2x"></i></a></h3>

          </div>
          <div class="modal-body-crop">
            <transition name="fade">
              <img v-if="display.image" :src="newImage == undefined ? `/${image.full}` : newImage.preview" alt="image.description" class="cover-imgCouv boxShadow" ref="image">
            </transition>
            <div class="form-group buttons">
              <input v-if="inputLoaded" type="file" :name="name" :ref="'input-file-' + index" @change="loadImage()">
              <input type="hidden"  name="" ref="jcrop">
              <input type="hidden" v-model="jcrop.JcropH" :name="'JcropH['+ index +']'">
              <input type="hidden" v-model="jcrop.JcropW" :name="'JcropW['+ index +']'">
              <input type="hidden" v-model="jcrop.JcropY" :name="'JcropY['+ index +']'">
              <input type="hidden" v-model="jcrop.JcropX" :name="'JcropX['+ index +']'">
            </div>
          </div>
          <div class="modal-footer">
              <button v-if="display.cropButton && !display.crop" class="btn btn-outline blue btn-block visible-xs" @click.prevent="triggerCrop()">
                Redimentionner&nbsp;
                <i class="far fa-image"></i>
              </button>
              <button v-if="display.cropButton && !display.crop" class="btn pull-left  btn-outline blue hidden-xs" @click.prevent="triggerCrop()">
                Redimentionner&nbsp;
                <i class="far fa-image"></i>
              </button>
              <!-- <a v-if="display.unloadButton" class="btn  red btn-block visible-xs" @click.prevent="unloadImage()" :href="'#modal-' + index" data-toggle="modal">
                Annuler &nbsp;
                <i class="fas fa-times"></i>
              </a>
              <a v-if="display.unloadButton" class="btn pull-right red hidden-xs" @click.prevent="unloadImage()" :href="'#modal-' + index" data-toggle="modal">
                Annuler &nbsp;
                <i class="fas fa-times"></i>
              </a>
              <button v-if="display.unloadButton || display.crop" class="btn green" @click.prevent="validateCrop()"  data-dismiss="modal" >
              </a> -->
              <button v-if="display.unloadButton || display.crop" class="btn green" @click.prevent="validateCrop()"  data-dismiss="modal">
                Valider &nbsp;
                <i class="fas fa-check"></i>
              </button>
              <button v-if="display.crop" class="btn red" @click.prevent="cancelCrop()">
                Retour &nbsp;
                <i class="fas fa-times"></i>
              </button>
          </div>
        </div>
      </div>
    </div>
    <a :href="'#modal-' + index" data-toggle="modal" class="btn blue btn-block" @click.prevent="triggerInput()" ><span v-html="btn"></span>&nbsp;</a>
    <button class="btn green btn-block" type="Submit" v-if="this.upload === 'default' && this.newImage != undefined" style="margin-top: .4em">Sauvegarder l'image</button>
  </div>
</template>

<script>
import Crop from '../../crop';


export default {
  name: 'ImageSimpleUpload',
  props: {
    image: undefined,
    name: String,
    crop: Boolean,
    ratio: {
      type: Number,
      default: NaN
    },
    index: {
      type: Number,
      default: 0
    },
    btn: String,
    upload: {
      type: String,
      default: 'default'
    },
    path: {
      type: String,
      default: '#'
    }
  },
  data () {
    return {
      newImage: undefined,
      inputLoaded: true,
      customCrop: undefined,
      display: {
        image: false,
        crop : false,
        unloadButton : false,
        cropButton : false,
      },
      jcrop: {
        JcropH: [],
        JcropW: [],
        JcropY: [],
        JcropX: []
      }
    }
  },
  mounted () {
    if (this.image != undefined) {
      this.display.image = true;
    }

    this.$refs['jcrop'].name = 'jcrop['+this.name+']'
    this.$refs['jcrop'].value = this.index
  },
  computed: {
    imagePath() {
      if (this.newImage == undefined && this.image != undefined) {
        return '/default.png'
      } else if(this.image != undefined && this.newImage != undefined) {
        return this.newImage.preview
      } else {
        return `/${this.image.full}`
      }
    }
  },
  methods: {
    triggerInput () {
      this.$refs['input-file-' + this.index].click();
      this.display.unloadButton = true;
    },
    loadImage () {
      this.newImage = new Image(this.$refs['input-file-' + this.index], this);
    },
    unloadImage () {
      this.newImage.unload();
    },
    triggerCrop () {
      this.customCrop = new Crop(this, this.$refs['image']);
      this.customCrop.trigger();
    },
    cancelCrop () {
      this.customCrop.cancel()
    },
    validateCrop () {
      if (this.customCrop != undefined) {
        this.customCrop.validate();
      }
      if (this.upload === 'ajax') {
        this.newImage.send(this.name, this.path)
      }
    }
  }
};
</script>

<style lang="css" scoped>
  input {
    display: none;
  }

  .cover-imgCouv {
    object-fit: cover;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    border: 1px solid rgb(0, 0, 0);
    margin-bottom: .5rem;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .buttons{
    margin-top: 2rem;
  }
</style>
